<template>
  <div id="app">
    <router-view/>
    <CarregandoInfo/>
    <FooterFixo/>
  </div>
</template>

<script>

import store from '@/store'
import "@fortawesome/fontawesome-free/css/all.min.css";
import CarregandoInfo from './components/CarregandoInfo.vue';
import FooterFixo from "./components/FooterFixo.vue"

export default {
  components: {
      FooterFixo,
      CarregandoInfo
    },
    name: 'App',
    methods: {
      atualizaConfiguracao() {
        var css = this.configuracao && this.configuracao.customStyle ? this.configuracao.customStyle: '',
        head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style');

        head.appendChild(style);

        style.type = 'text/css';
        if (style.styleSheet){
          // This is required for IE8 and below.
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }
      }
    },
    computed: {
      configuracao() {
        return store.state.dadosJson.configuracao
      }
    },
    watch: {
      configuracao(){
        this.atualizaConfiguracao();
      }
    },
    mounted() {
      store.dispatch('obterDadosJson');
    }
}
</script>

<style>

@import "https://cdn.jsdelivr.net/npm/bulma@0.9.4/css/bulma.min.css";

html {
  overflow: auto;
}

#app {
    /* background-color: #DCDCDC; */
    background-image: linear-gradient(to bottom, #c8c8c8, #d6d6d6, #e3e3e3, #f1f1f1);
    font-family: 'Roboto';
    min-height: 100vh;
}

* {
    padding:0;
    margin:0;
    box-sizing: border-box;
    transition: all 0.3s ease-in;
}

body {
  width: 100%;
  height: 100%;
}
</style>
